import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import AdminRouts from './router/AppRouts';
import NavMenuLinks from './navigation/NavMenuLinks';
import { updateUnreadMessagesQuantity } from '../actions/conversations';
import { acceptTermsAction, acceptClientServiceAgreement } from '../actions/users';
import { logOut } from '../actions/auth';
import UsersService from '../services/UsersService';
import TermsConfirmationModal from './app/TermsConfirmationModal';

class AdminApp extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    totalUnreadMessages: PropTypes.number.isRequired,
    asideMenuIsAvailable: PropTypes.bool.isRequired,
    updateUnreadMessagesQuantity: PropTypes.func.isRequired,
    logOut: PropTypes.func.isRequired,
    acceptTermsAction: PropTypes.func.isRequired,
    acceptClientServiceAgreement: PropTypes.func.isRequired
  };

  state = {
    termsModalIsOpen: true
  };

  componentDidMount () {
    this.props.updateUnreadMessagesQuantity();
  }

  closeTermsModal = () => {
    this.setState({
      termsModalIsOpen: false
    });
  };

  acceptTermsAndAgreement = () => {
    this.props.acceptTermsAction().then(data => {
      if (data) {
        this.props.acceptClientServiceAgreement().then(data => {
          if (data) {
            this.closeTermsModal();
          }
        });
      }
    });
  };

  cancelTermsAndAgreement = () => {
    this.props.logOut();
  };

  render () {
    const { user } = this.props;
    if (!user.userid) {
      return <Redirect to='/' />;
    }

    if (UsersService.isEmployer()) {
      const { tc_accepted_date, client_service_agreement_accepted_on } = this.props.user;
      const { termsModalIsOpen } = this.state;
      if (!tc_accepted_date || !client_service_agreement_accepted_on) {
        return (
          <TermsConfirmationModal
            isOpen={termsModalIsOpen}
            closeModal={this.closeTermsModal}
            acceptTermsAndAgreement={this.acceptTermsAndAgreement}
            cancelTermsAndAgreement={this.cancelTermsAndAgreement}
          />
        );
      }
    }

    return (
      <div className='main-wrapper'>
        { UsersService.isAdmin() && this.props.asideMenuIsAvailable && (
          <aside className='aside menu-desktop'>
            <NavMenuLinks totalUnreadMessages={this.props.totalUnreadMessages} />
          </aside>
        )}
        <AdminRouts {...this.props} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    totalUnreadMessages: state.conversations.totalUnreadMessages,
    asideMenuIsAvailable: state.asideMenuIsAvailable
  };
};

const mapDispatchToProps = {
  updateUnreadMessagesQuantity,
  logOut,
  acceptTermsAction,
  acceptClientServiceAgreement
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminApp);



// WEBPACK FOOTER //
// ./src/components/AdminApp.js